import React from "react"
import LayoutChild from "../components/layoutChild"
import SEO from "../components/seo"
import { color, fontSize, space } from '../components/constants'
import styled from 'styled-components'
import { graphql } from "gatsby"
import Img from "gatsby-image";


const PageLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 36px;
    margin: 0px 36px 72px;

    @media (max-width: 1024px){
        grid-gap: 24px;
        margin: 0px 24px 24px;
    }

    @media (max-width: 640px){
        grid-template-columns: 100% ;
        ${'' /* grid-template-rows: 100%; */}
        grid-gap: 24px;
        margin: 0px 24px 24px;
    }
`
/* Text Group */
const CellTitleGroup = styled.div`
    width: 75%;
    @media (max-width: 640px){
        ${'' /* grid-row: 2; */}
        width: 75%;
        margin-top: 8px;
    }

`
const Title = styled.div`
    color: white;
    font-size: ${fontSize[3]};
    font-weight: 200;
    margin-top: ${space[4]+ "px"};
    line-height: 0.8;
    word-wrap:normal; /* YESSSSS */
    text-rendering: optimizeLegibility;

    @media (max-width: 1024px){
        font-size: ${fontSize[2]};
    }

    @media (max-width: 640px){
        word-spacing: normal;
        font-size: ${fontSize[2]};
    }

`
const Text = styled.p`
    margin-top: ${space[2]+ "px"};
    word-wrap:normal; /* YESSSSS */
    color: ${color.gray2};
    @media (max-width: 1024px){
        font-size: 16px;
    }
`
const Subhead = styled.p`
    margin-top: ${space[4]+ "px"};
    word-wrap:normal; /* YESSSSS */
    color: white;
    margin-bottom: 0px;
    @media (max-width: 1024px){
        font-size: 16px;
    }
`
/* Image styles */

const ImgSingle = styled(Img)`
    border-radius: 24px;
`
const ImgDouble = styled(Img)`
    border-radius: 24px;
    grid-column: 1 / span 2;
    @media (max-width: 640px){
        grid-column: 1 / span 1;
    }
`

export default ({ data }) => (
  <LayoutChild>
    <SEO 
      title="beme"
      description="Most authentic way to share your experience."
      image="../images/card.jpg"
    />
    <PageLayout>
        <CellTitleGroup>
            <Title >beme</Title>
            <Subhead>ROLE: UX LEAD&nbsp;DESIGNER</Subhead>
            <Text>Beme is a video-sharing app developed by Casey Neistat and Matt Hackett. with a novel recording method, the app allowed interesting strangers from all over the world share 4 second moments and build&nbsp;relationships.
            </Text>
            <Text>RESPONSIBILITIES: Research, concept, interaction design, design system, visual design, and&nbsp;prototyping.</Text>
            <Subhead>2016 WEBBY WINNER - MOBILE SITES &&nbsp;APP&nbsp;-&nbsp;SOCIAL</Subhead>
            <Subhead>Research, concept, interaction design, design system, visual design, and&nbsp;prototyping.</Subhead>
            </CellTitleGroup>
            <ImgSingle 
                fluid={data.imageOne.childImageSharp.fluid}
                alt="An image of the Scroll Reader App"
                fadeIn={true}
                 />
            <ImgSingle 
                fluid={data.imageTwo.childImageSharp.fluid}
                alt="An image of the beme App"
                fadeIn={true}
                 />
            <ImgSingle
                fluid={data.imageThree.childImageSharp.fluid}
                alt="An image of the beme App"
                fadeIn={true}
                 />
            <ImgDouble
                fluid={data.imageFour.childImageSharp.fluid}
                alt="An image of the beme App"
                fadeIn={true}
                 />
            <ImgDouble 
                fluid={data.imageFive.childImageSharp.fluid}
                alt="An image of the beme App"
                fadeIn={true}
                 />
            <ImgDouble 
                fluid={data.imageSix.childImageSharp.fluid}
                alt="An image of the beme App"
                fadeIn={true}
                 />
            <ImgDouble 
                fluid={data.imageSeven.childImageSharp.fluid}
                alt="An image of the beme App"
                fadeIn={true}
                 />
        </PageLayout>
  </LayoutChild>
)

export const query = graphql`
  query {
    imageOne: file(relativePath: { eq: "beme/beme-1.webp" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    imageTwo: file(relativePath: { eq: "beme/beme-2.webp" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    imageThree: file(relativePath: { eq: "beme/beme-3.webp" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    imageFour: file(relativePath: { eq: "beme/beme-4.webp" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    imageFive: file(relativePath: { eq: "beme/beme-5.webp" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      imageSix: file(relativePath: { eq: "beme/beme-6.webp" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      imageSeven: file(relativePath: { eq: "beme/beme-7.webp" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
  }
`